import posthog, { type CaptureOptions } from 'posthog-js';
import type { EventName, EventProperties } from '../eventNames';

/**
 * 手動イベント送信ラッパー（最小セット用）。
 *
 * ⚠️ クリック / ページ遷移 / フォーム submit はここで送らない（Autocapture に任せる）。
 * 使うのは {@link EVENT_NAMES} に定義した手動イベント最小セットのみ。
 *
 * イベント名とプロパティ型は {@link EventProperties} で紐付くため、
 * 未定義イベントや不正なプロパティはコンパイルエラーになる。
 *
 * @param options posthog.capture のオプション。離脱時など「ページが閉じる瞬間でも確実に送りたい」
 *   イベントは `{ send_instantly: true, transport: 'sendBeacon' }` を渡す。
 *   既定のバッチキューだと unload に間に合わず欠損するため、即時 beacon 送信に切り替える。
 */
export function trackEvent<E extends EventName>(
  name: E,
  properties: EventProperties[E],
  options?: CaptureOptions,
): void {
  // init 前（テスト / KEY 未設定）は送信しない。
  if (!posthog.__loaded) return;
  if (options) {
    posthog.capture(name, properties, options);
  } else {
    posthog.capture(name, properties);
  }
}
